import i18n from '~/components/i18n'

export const getAbortOfferColumns = (amountUnit, priceLabel) => {
  return [
    {
      name: i18n.t('Trading month'),
      key: 'date',
      type: 'dateRibbon',
      format: 'MMM YYYY'
    },
    {
      name: i18n.t('Amount (in {{amountUnit}})', { amountUnit }),
      key: 'amount',
      type: 'number-whole'
    },
    {
      name: i18n.t('Price {{priceLabel}}', { priceLabel }),
      key: 'price',
      type: 'no-unit-number'
    },
    {
      name: i18n.t('Status'),
      key: 'statusLabel'
    },
    {
      name: i18n.t('Supplier No.'),
      key: 'supplierNo'
    },
    {
      name: i18n.t('Unique id'),
      key: 'uniqueId'
    }
  ]
}